import { defineStore } from "pinia";

export const useLangStore = defineStore("language", {
  state: () => ({
    data: null as any,
  }),
  actions: {
    getData(): any {
      return localStorage.getItem("language");
    },
    setData(data: any) {
      localStorage.setItem("language", data);
    },
    clear() {
      localStorage.removeItem("language");
    },
  },
});
